import React, {useContext, useEffect, useState} from 'react';
import {usePunchContext} from "../../../context/punchContext";
import {formatTime} from "../../../utility/utility";
import dayjs from "dayjs";
import EmployeePunchCardView from "./employee-punch-card.view";
import toastify from "../../../common/toastify";
import dashboard from "../../../resources/dashboard";
import {PunchesData} from "../../../domains/models/attendance/attendance";
import UserLoginContext from "../../../context/userLoginContext";

interface IState {
    punchStatus: {
        time: string,
        punchDateTime: string
    }
}

const initialValue = {
    time: '--:--',
    punchDateTime: ''
}

const EmployeePunchCard = () => {

    const {user} = useContext(UserLoginContext);
    const {fetchPunchRecords, records, isCheckedIn, markCheckIn, markCheckOut, isLoading} = usePunchContext();
    const resources = dashboard.attendanceWidget.EmployeeAttendanceWidget;


    const [state, setState] = useState<IState>({
        punchStatus: initialValue
    });


    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        calculatePunchStatus(records);
    }, [records])

    async function loadData() {
        const today = dayjs();
        await fetchPunchRecords(user.employeeId, today, today, 0, 20);
    }


    function calculatePunchStatus(records: PunchesData[]) {

        const today = dayjs().format("YYYY-MM-DD");
        const todayPunchRecord = records.filter((item) => item.date === today);

        if (todayPunchRecord.length !== 0) {
            const latest = todayPunchRecord[0];
            const timestamp = `${latest.date}T${latest.time}`;
            setState({
                punchStatus: {
                    time: formatTime(timestamp),
                    punchDateTime: timestamp
                }
            });
        }
    }


    const handleCheckout = async () => {
        try {
            await markCheckOut();
            toastify({
                title: resources.checkOut.title,
                isSuccessful: true,
                message: resources.checkOut.message
            });
        } catch (error) {
            console.error("Attendance action failed:", error);
        }
    }

    const handleCheckIn = async () => {
        try {
            await markCheckIn();
            toastify({
                title: resources.checkIn.title,
                isSuccessful: true,
                message: resources.checkIn.message
            });
        } catch (error) {
            console.error("Attendance action failed:", error);
        }
    };

    return (
        <EmployeePunchCardView
            isLoading={isLoading}
            punchStatus={state.punchStatus}
            isCheckedIn={isCheckedIn}
            handleCheckIn={handleCheckIn}
            handleCheckout={handleCheckout}
        />
    )
}

export default EmployeePunchCard;
